module.exports = __webpack_public_path__ + "static/media/screenshot-05.3a52eb4b.jpg";